var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73058 8.18815C6.73058 9.0435 6.03718 9.7369 5.18183 9.7369C4.32648 9.7369 3.63308 9.0435 3.63308 8.18815C3.63308 7.3328 4.32648 6.6394 5.18183 6.6394C6.03718 6.6394 6.73058 7.3328 6.73058 8.18815Z",
    fill: "#F7D064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18183 11.2856C4.09503 11.2856 3.16511 11.9573 2.7845 12.9082C2.66585 13.2046 2.60059 13.5281 2.60059 13.8669V14.8994H7.76308V13.8669C7.76308 13.5281 7.69781 13.2046 7.57917 12.9082C7.19856 11.9573 6.26863 11.2856 5.18183 11.2856Z",
    fill: "#F7D064"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73058 8.18815C6.73058 9.0435 6.03718 9.7369 5.18183 9.7369C4.32648 9.7369 3.63308 9.0435 3.63308 8.18815C3.63308 7.3328 4.32648 6.6394 5.18183 6.6394C6.03718 6.6394 6.73058 7.3328 6.73058 8.18815Z",
    stroke: "#F7D064",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18183 11.2856C4.09503 11.2856 3.16511 11.9573 2.7845 12.9082C2.66585 13.2046 2.60059 13.5281 2.60059 13.8669V14.8994H7.76308V13.8669C7.76308 13.5281 7.69781 13.2046 7.57917 12.9082C7.19856 11.9573 6.26863 11.2856 5.18183 11.2856Z",
    stroke: "#F7D064",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8927 8.18815C16.8927 9.0435 16.1993 9.7369 15.3439 9.7369C14.4886 9.7369 13.7952 9.0435 13.7952 8.18815C13.7952 7.3328 14.4886 6.6394 15.3439 6.6394C16.1993 6.6394 16.8927 7.3328 16.8927 8.18815Z",
    fill: "#F7D064"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3439 11.2856C14.2571 11.2856 13.3272 11.9573 12.9466 12.9082C12.828 13.2046 12.7627 13.5281 12.7627 13.8669V14.8994H17.9252V13.8669C17.9252 13.5281 17.8599 13.2046 17.7413 12.9082C17.3607 11.9573 16.4307 11.2856 15.3439 11.2856Z",
    fill: "#F7D064"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8927 8.18815C16.8927 9.0435 16.1993 9.7369 15.3439 9.7369C14.4886 9.7369 13.7952 9.0435 13.7952 8.18815C13.7952 7.3328 14.4886 6.6394 15.3439 6.6394C16.1993 6.6394 16.8927 7.3328 16.8927 8.18815Z",
    stroke: "#F7D064",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3439 11.2856C14.2571 11.2856 13.3272 11.9573 12.9466 12.9082C12.828 13.2046 12.7627 13.5281 12.7627 13.8669V14.8994H17.9252V13.8669C17.9252 13.5281 17.8599 13.2046 17.7413 12.9082C17.3607 11.9573 16.4307 11.2856 15.3439 11.2856Z",
    stroke: "#F7D064",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3627 5.79995C12.3627 6.95975 11.4225 7.89995 10.2627 7.89995C9.1029 7.89995 8.1627 6.95975 8.1627 5.79995C8.1627 4.64015 9.1029 3.69995 10.2627 3.69995C11.4225 3.69995 12.3627 4.64015 12.3627 5.79995Z",
    fill: "#E4AB10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2627 9.99995C8.78907 9.99995 7.52815 10.9107 7.01207 12.2C6.85119 12.6019 6.7627 13.0406 6.7627 13.5V14.9H13.7627V13.5C13.7627 13.0406 13.6742 12.6019 13.5133 12.2C12.9972 10.9107 11.7363 9.99995 10.2627 9.99995Z",
    fill: "#E4AB10"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3627 5.79995C12.3627 6.95975 11.4225 7.89995 10.2627 7.89995C9.1029 7.89995 8.1627 6.95975 8.1627 5.79995C8.1627 4.64015 9.1029 3.69995 10.2627 3.69995C11.4225 3.69995 12.3627 4.64015 12.3627 5.79995Z",
    stroke: "#E4AB10",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2627 9.99995C8.78907 9.99995 7.52815 10.9107 7.01207 12.2C6.85119 12.6019 6.7627 13.0406 6.7627 13.5V14.9H13.7627V13.5C13.7627 13.0406 13.6742 12.6019 13.5133 12.2C12.9972 10.9107 11.7363 9.99995 10.2627 9.99995Z",
    stroke: "#E4AB10",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.1d9bc9f45e1c3ec4a98ce8f193bff052.svg";
export { ForwardRef as ReactComponent };